import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import {Product} from '../../../models/product.model';
import {BRAND, CATEGORY, PROGRAM, ITEM_TYPE, CHANNEL} from '../../../constants/filter-types';
import {Router} from '@angular/router';
import {PageService} from '../../../services/page.service';
import { EUDRService } from '../../../services/eudr.service';
import { takeWhile } from 'rxjs/operators';

const linkedTypes = [BRAND, CATEGORY, PROGRAM, ITEM_TYPE, CHANNEL];

@Component({
    selector: 'product-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ProductDetailsComponent implements OnInit, OnDestroy {
    @Input() public product: Product;

    public isOpen = false;
    public eudrFooterMessage: string | null = null;
    private alive = true;

    constructor(
        private router: Router,
        private pageService: PageService,
        private eudrService: EUDRService
    ) {
    }

    ngOnInit() {
        // Subscribe to EUDR footer message
        this.eudrService.getFooterMessage().pipe(takeWhile(() => this.alive)).subscribe(message => {
            this.eudrFooterMessage = message;
        });
    }

    ngOnDestroy() {
        this.alive = false; // Clean up subscriptions
    }

    expandDrawer(e) {
        this.isOpen = !this.isOpen;
        e.preventDefault();
    }

    getSkus() {
        const skuArray = this.product.skus.map(s => s.getDisplaySkuID());
        if (skuArray.length > 1) {
            return `<span><strong>SKUS#</strong> ${skuArray.join(', ')}</span>`;
        } else {
            return `<span><strong>SKU#</strong> ${skuArray}</span>`;
        }
    }


    get vendorLabel(): string {
        if (!this.product) {
            return '';
        }

        return this.product.getVendor();
    }

    isLink(key: string) {
        return linkedTypes.includes(key);
    }

    navigateTo(type: string, value: string) {
        const path  = this.product.rootPath;
        this.pageService.preselectedFilter = {path, type, value};
        this.router.navigate([path]);
        return false;
    }
}
